import { useQuery } from 'react-query';
import { UserSelectionService } from '../services/UserSelectionService';

export const USER_SELECTION_QUERY = 'user_selection';

export const useUsers = () =>
  useQuery(USER_SELECTION_QUERY, () => UserSelectionService.list());
